/* Copyright (c) 2017 Backpack Health LLC */


let zxcvbn = null;

const PasswordStrength = {

  requireDependency() {
    import(/* webpackChunkName: "zxcvbn" */ 'zxcvbn').then(d => {
      zxcvbn = d.default;
    });
  },

  getScore(value) {
    return zxcvbn === null ? 0 : zxcvbn(value).score;
  },

  isStrongEnough(score) {
    return score > 0;
  },

};

export default PasswordStrength;
